import { memo } from 'react';

import { ShareButton } from '~/components/AssetModalV2/Header/components/ShareButton';
import { useShowcaseAssetShare } from '~/components/AssetModalV2/Header/PublicShowcaseAssetComponents/useShowcaseAssetShare';
import { ASSET_SHARE_BUTTON_PUBLIC } from '~/constants/testIDs';

export const ShowcaseAssetShareButton = memo(() => {
  const { shareShowcaseAsset } = useShowcaseAssetShare();

  return <ShareButton onClick={shareShowcaseAsset} dataTestId={ASSET_SHARE_BUTTON_PUBLIC} />;
});

ShowcaseAssetShareButton.displayName = 'ShowcaseAssetShareButton';
